import React, { FunctionComponent } from 'react';
import { MetaDataModel } from '../../services/content/meta/models/MetaDataModel';
import { ArticleListing } from '../Partials/ArticleListing/ArticleListing';
import { Pagination } from '../Partials/Pagination/Pagination';
import { useRouter } from 'next/router';
import { GoogleAdDesktop } from '../Ads/GoogleAdDesktop';
import { ads } from '../../services/ads/constants';
import { AdBackground } from '../Ads/AdBackground';
import { ArticlePartialModel } from '../../services/content/article/models/ArticlePartialModel';

type Props = {
    articles: ArticlePartialModel[];
    meta: MetaDataModel | null;
    slug: string;
    page: string;
};
export const CategoryPageListing: FunctionComponent<Props> = ({ articles, meta, slug, page }) => {
    const router = useRouter();

    return (
        <>
            <div className='row'>
                <div className='col-12 col-md-9 col-lg-9'>
                    <ArticleListing articles={articles} />
                    <div className='w-100 d-flex flex-row justify-content-end'>
                        <Pagination
                            meta={meta}
                            onPageClick={(page) => {
                                router.push(page > 1 ? `/${slug}/${page}` : `/${slug}`);
                            }}
                            page={page}
                        />
                    </div>
                </div>
                <div className='d-none d-md-block col-12 col-md-3 col-lg-3 text-center'>
                    <AdBackground className='sticky-ad'>
                        <GoogleAdDesktop ad={ads[10]} />
                    </AdBackground>
                </div>
            </div>
        </>
    );
};
